export const KLIP_HEADER_TEXT = 'ABC WALLET';

export const ANIMATION_DURATION = 10;
export const DEFAULT_BUTTON_COLOR = 'rgb(64, 153, 255)';

export const KLIP_WRAPPER_ID = 'klip-wrapper';
export const KLIP_STYLE_ID = 'klip-style-sheet';
export const KLIP_MODAL_ID = 'klip-qrcode-modal';
export const KLIP_CLOSE_BUTTON_ID = 'klip-qrcode-close';
export const KLIP_CTA_TEXT_ID = 'klip-qrcode-text';
export const KLIP_CONNECT_BUTTON_ID = 'klip-connect-button';
